export default __webpack_public_path__ + "static/media/13185 - PaperD.8368411e.jpeg";